import { ApiRequest } from "src/models/api.request";
import GnlLanguageDTO from "src/models/GenelTanimlar/language";
import api from "src/services/core/api";

const controllerName = "GnlLanguageDTO";

export const languageApi = api.injectEndpoints({
    endpoints: builder => ({
        getLanguageByNamespace: builder.query<Array<GnlLanguageDTO>, { lang: string, ns: string }>({
            query: (request) => {
                let apiReq: ApiRequest<GnlLanguageDTO> = {
                    paging: false,
                    filters: {
                        groupOperator: 'and',
                        predicates: [
                            { fieldName: 'dil', operator: '=', value1: request.lang },
                            { fieldName: 'namespace', operator: '=', value1: request.ns }
                        ]
                    },
                    sorts: [{
                        fieldName: "path"
                    },
                    {
                        fieldName: "label"
                    }]
                }
                return {
                    url: controllerName + "/find",
                    method: "POST",
                    body: apiReq
                }
            },
            providesTags: ["LanguageParameters"]
        }),
        languageUpdate: builder.mutation<GnlLanguageDTO, GnlLanguageDTO>({
            query: (request) => ({
                url: controllerName,
                method: "PUT",
                body: request
            }),
            //invalidatesTags: ["LanguageParameters"]
        }),
        localesLoad: builder.query<any, {
            url: string
        }>({
            query: (request) => ({
                url: "locales/" + request.url,
                method: "POST"
            }),
            providesTags: ["Locales"]
        }),
        localesAdd: builder.mutation<any, {
            url: string,
            payload: any,
        }>({
            query: (request) => ({
                url: "locales/" + request.url,
                method: "POST",
                body: request.payload
            })
        }),
    }),
})

export const { useGetLanguageByNamespaceQuery, 
    useLanguageUpdateMutation, 
    useLazyLocalesLoadQuery,
    useLocalesAddMutation } = languageApi;